import axios from "axios";
import * as CONSTANTS from "./constants";

// Sessiion managmement CRUD operations 

export const createSession = (data) => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/session/create`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.data.success === true) {
      dispatch({type:CONSTANTS.SESSION_CREATE,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.SESSION_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllActiveSession = () => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/session/get_active_sessions/`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.SESSION_GET_ACTIVE_SUCCESS, payload:response.data.session})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.SESSION_GET_ACTIVE_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};
export const getAllCompleteSession = () => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/session/get_completed_sessions/`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.SESSION_GET_COMPLETE,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.SESSION_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const CompleteSession= (id,data) => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/session/complete_session/${id}`,
      //  `https://17e2-14-194-97-174.ngrok-free.app/api/v1/session/complete_session/${id}`,
       data,
      
      {
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
     console.log("resp", response);
    if (response && response.status ===200 && response.data) {
      dispatch({type:CONSTANTS.SESSION_COMPLETE,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.SESSION_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteSession= (id) => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/session/delete_session/${id}`,
      
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.SESSION_DELETE,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.SESSION_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateSession = (data, id) => async (dispatch, getState) => {
 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/session/update_session/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.SESSION_UPDATE_SUCCESS,payload:response.data})
      return response;
    }else {
      dispatch({type:CONSTANTS.SESSION_UPDATE_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const viewSession = (id) => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/session/get_one_session/${id}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    if (response && response.data.success === true) {
      dispatch({type:CONSTANTS.SESSION_VIEW,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.SESSION_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const lunchSession= (id,data) => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/session/launch_session/${id}`,
      // `https://1bd0-14-194-97-174.ngrok-free.app/api/v1/session/launch_session/${id}`,
       data,
      
      {
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status ===200 && response.data) {
      dispatch({type:CONSTANTS.SESSION_LUNCH,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.SESSION_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

//End

// Profile Update(users and admin)
// export const updateAdminProfile = (data) => async (dispatch, getState) => {
//     try {
//     const access_token = getState().auth.access_token;
//     const response = await axios.put(`${process.env.REACT_APP_API_ENDPOINT}/users/update_user`,
//       data,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${access_token}`,
         
//         },
//       }
//     );
//     if (response && response.status === 200 && response.data) {
//       dispatch({ type: CONSTANTS.USER_PROFILEUPDATE, payload: response.data });
//       return response;
//     } else {
//       dispatch({ type: CONSTANTS.USER_FAILLED, payload: null });
//       return Promise.reject(new Error(response.message));
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

export const getUserProfile = () => async (dispatch, getState) => {
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/users/get/`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    if (response && response.data.success === true) {
      dispatch({type:CONSTANTS.USER_GET_ALL ,payload:response.data})
      return response.data;
    }
    else {
      dispatch({type:CONSTANTS.USER_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const changePassword = (data) => async (dispatch, getState) => {
  
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/users/change_password`,
      data,
      {
        headers: { 
        'Content-Type': 'application/json', 
        Authorization: `Bearer ${access_token}`,
      },}
    );

    if (response.status === 200 && response.data) {
      dispatch({ type: CONSTANTS.PASSWORD_UPDATE, payload: response.data });
      return response.data;
    } else {
      dispatch({ type: CONSTANTS.PASSWORD_FAILED, payload: null });
      return { success: false };
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: CONSTANTS.PASSWORD_FAILED, payload: null });
    return Promise.reject(error);
  }
};
//End
// Reset Password
export const resetPassword = (data) => async (dispatch, getState) => {
  try {
    
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/users/reset_password`,
      data
    );
    

    if (response.status === 200 && response.data) {
      dispatch({ type: CONSTANTS.PASSWORD_UPDATE, payload: response.data });
      return response.data;
    } else {
      dispatch({ type: CONSTANTS.PASSWORD_FAILED, payload: null });
      return { success: false };
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: CONSTANTS.PASSWORD_FAILED, payload: null });
    return Promise.reject(error);
  }
};



// User Management Section

export const getAllUsers = () => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/users/get_all/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.USER_GET_ALL ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.USER_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};


export const createUser = (data) => async (dispatch, getState) => {   
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/users/create`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.data.success === true) {
      dispatch({type:CONSTANTS.CREATE_USER,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.USER_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};


export const userUpdate = (data, id) => async (dispatch, getState) => {
  try {
  
    const access_token = getState().auth.access_token;
    const response = await axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/users/update_user/${id}`,data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch( {type:CONSTANTS.UPDATE_USER_SUCCESS  , payload : response.data})
      return response.data;
    }else  {
      dispatch({type:CONSTANTS.UPDATE_USER_FAILED , payload : null})
      return Promise.reject(new Error(response.message))
    }
  } catch (error) {
    console.log(error);
  }
};


export const getOneUser = (id) => async (dispatch, getState) => {
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/users/get_user/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteUser= (id) => async (dispatch, getState) => { 
  
  try {
    
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/users/delete_user/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.DELETE_USER,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.USER_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

//End

//Sop generation

export const createSop= (id) => async (dispatch, getState) => {   
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/sop/create/${id}`,
      // `https://69cc-14-194-97-174.ngrok-free.app/api/v1/sop/create/${id}`,
      
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.data.success === true) {
      dispatch({type:CONSTANTS.CREATE_SOP,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.FAILED_SOP,payload:null})
      // return Promise.reject(new Error(response.message));
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const downloadSop= () => async (dispatch, getState) => {   
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/session/generated_sop/`,
      // `https://69cc-14-194-97-174.ngrok-free.app/api/v1/session/generated_sop/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.data.success === true) {
      dispatch({type:CONSTANTS.DOWNLOAD_SOP,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.FAILED_SOP,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const viewSop= (id) => async (dispatch, getState) => {   
  try {  
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/sop/get_html_sop/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.VEIW_SOP,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.FAILED_SOP,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const editSop = (data) => async (dispatch, getState) => {   
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/sop/edit_sop`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.EDIT_SOP,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.USER_FAILLED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const micData = (data,id) => async (dispatch, getState) => {  
  
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API}/transcript/mic_data/${id}`,
      // `https://sop.24livehost.com/transcript/mic_data/${id}`,
      // `https://08d3-14-194-97-174.ngrok-free.app/transcript/mic_data/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.MIC_DATA_SUCCESS, payload:response})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.MIC_DATA_FAILED, payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};
//End

//Sop generation
export const createFaq = (formData) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/audio/upload_audio`;
      const response = await axios.post(
        url,
          // `https://757d-14-194-97-174.ngrok-free.app/api/v1/audio/upload_audio`,
          formData,
          {
              headers: {
                  // 'Content-Type': 'multipart/form-data',
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.CREATE_FAQ_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.CREATE_FAQ_FAILED, payload: null });
          return Promise.reject(new Error('Failed to upload the audio file.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.CREATE_FAQ_FAILED, payload: error });
      console.error('Error uploading FAQ audio:', error);
      return Promise.reject(error);
  }
};
export const getAllFaq = () => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/audio/get_completed_audios/`,
      // `https://757d-14-194-97-174.ngrok-free.app/api/v1/audio/get_completed_audios/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.GET_ALL_FAQ_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.GET_ALL_FAQ_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteFaq= (id) => async (dispatch, getState) => {   
  try {  
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/audio/delete_audio/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.DELETE_FAQ_SUCCESS,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.DELETE_FAQ_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

//end

//Question generation
export const questionData = (data) => async (dispatch, getState) => {  
  
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/questions/recommend_questions`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.GET_QUESTION_SUCCESS, payload:response})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.GET_QUESTION_FAILED, payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const updatesRelevant = (data) => async (dispatch, getState) => {  
  
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/questions/update_relevance`,
      // `https://sop.24livehost.com/transcript/mic_data/${id}`,
      // `https://6c0f-14-194-97-174.ngrok-free.app/api/v1/questions/update_relevance`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.RELEVANT_SUCCESS, payload:response})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.RELEVANT_FAILED, payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getQuestionList = (data) => async (dispatch, getState) => {  
  
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      // `${process.env.REACT_APP_API_ENDPOINT}/questions/get_question`,
      `https://6c0f-14-194-97-174.ngrok-free.app/api/v1/questions/get_question`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.GET_QUESTION_LIST_SUCCESS, payload:response})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.GET_QUESTION_LIST_FAILED, payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const allMarkedQuestion = (data) => async (dispatch, getState) => {  
  
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      // `${process.env.REACT_APP_API_ENDPOINT}/questions/check_relevance_null/`,
      `https://6c0f-14-194-97-174.ngrok-free.app/api/v1/questions/check_relevance_null/`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.GET_ALL_MARKED_SUCCESS, payload:response})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.GET_ALL_MARKED_FAILED, payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

//end

//Video mangement

export const createVideoSession= (formData) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/create_video_session`;
      const response = await axios.post(
        url,
          formData,
          {
              headers: {
                  // 'Content-Type': 'multipart/form-data',
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.CREATE_VIDEO_SESSION_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.CREATE_VIDEO_SESSION_FAILED, payload: null });
          return Promise.reject(new Error('Failed to create the video session.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.CREATE_VIDEO_SESSION_FAILED, payload: error });
      console.error('Error to creating video session:', error);
      return Promise.reject(error);
  }
};

export const getAllVideoSession = () => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/video/list_video_sessions`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.FETCH_VIDEO_SESSION_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.FETCH_VIDEO_SESSION_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteVideoSession= (id) => async (dispatch, getState) => {   
  try {  
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/video/delete_video_session/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.DELETE_VIDEO_SESSION_SUCCESS,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.DELETE_VIDEO_SESSION_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const generateImageScript= (videoSessionId, data) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/generate_image_and_script/${videoSessionId}`;
      const response = await axios.post(
        url,
          data,
          {
              headers: {
                 ContentType: 'application/json', 
                 Accept: 'application/json', 
                 Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.GENERATE_IMAGE_SCRIPT_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.GENERATE_IMAGE_SCRIPT_FAILED, payload: null });
          return Promise.reject(new Error('Failed to generate image and script.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.GENERATE_IMAGE_SCRIPT_FAILED, payload: error });
      console.error('Error to generating image and script:', error);
      return Promise.reject(error);
  }
};

export const fetchListImageScript = (videoSessionId) => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/video/list_video_inputs_by_session_id/${videoSessionId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.FETCH_IMAGE_SCRIPT_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.FETCH_IMAGE_SCRIPT_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const uploadImageReplacement= (videoSessionId,itemId,cardId,formData) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/upload-replacement-image/${videoSessionId}/${cardId}/${itemId}`;
      const response = await axios.post(
        url,
          formData,
          {
              headers: {
                  'Content-Type': 'multipart/form-data',
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );
      if (response && response.data) {
          dispatch({ type: CONSTANTS.UPLOAD_IMAGE_REPLACEMENT_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.UPLOAD_IMAGE_REPLACEMENT_FAILED, payload: null });
          return Promise.reject(new Error('Failed to create the video session.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.UPLOAD_IMAGE_REPLACEMENT_FAILED, payload: error });
      console.error('Error to creating video session:', error);
      return Promise.reject(error);
  }
};
export const updateScript= (itemId, data) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/update_video_script/${itemId}`;
      const response = await axios.put(
        url,
          data,
          {
              headers: {
                 ContentType: 'application/json', 
                 Accept: 'application/json', 
                 Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.UPDATE_SCRIPT_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.UPDATE_SCRIPT_FAILED, payload: null });
          return Promise.reject(new Error('Failed to generate image and script.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.UPDATE_SCRIPT_FAILED, payload: error });
      console.error('Error to generating image and script:', error);
      return Promise.reject(error);
  }
};
export const deleteImageScript= (cardId) => async (dispatch, getState) => {   
  try {  
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/video/video-image-and-script/${cardId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.DELETE_IMAGE_SCRIPT_SUCCESS,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.DELETE_IMAGE_SCRIPT_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const createVideoInput= (cardId) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/create_video/${cardId}`;
      const response = await axios.post(
        url,
        {},
          {
              headers: {
               'Accept': 'application/json',
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.CREATE_VIDEO_INPUT_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.CREATE_VIDEO_INPUT_FAILED, payload: null });
          return Promise.reject(new Error('Failed to create the video session.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.CREATE_VIDEO_INPUT_FAILED, payload: error });
      console.error('Error to creating video session:', error);
      return Promise.reject(error);
  }
};

export const deleteVideoInput= (cardId ,videoSessionId) => async (dispatch, getState) => {   
  try { 
     
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/video/delete_video_input/${videoSessionId}/${cardId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.DELETE_VIDEO_INPUT_SUCCESS,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.DELETE_VIDEO_INPUT_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getOneVideocard= (videoSessionId,cardId) => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/video/list_video_inputs_by_session_id/${videoSessionId}/${cardId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.FETCH_VIDEO_CARD_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.FETCH_VIDEO_CARD_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};
//merge 
export const createMerge= (data) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/create_merge_request`;
      const response = await axios.post(
        url,
          data,
          {
              headers: {
                  // 'Content-Type': 'multipart/form-data',
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.CREATE_MERGE_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.CREATE_MERGE_FAILED, payload: null });
          return Promise.reject(new Error('Failed to create the video session.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.CREATE_MERGE_FAILED, payload: error });
      console.error('Error to creating video session:', error);
      return Promise.reject(error);
  }
};

export const uploadVideo= (formData ,videoSessionId) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/upload-merged-video/${videoSessionId}`;
      const response = await axios.post(
        url,
          formData,
          {
              headers: {
                  'Content-Type': 'multipart/form-data',
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.UPLOAD_VIDEO_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.UPLOAD_VIDEO_FAILED, payload: null });
          return Promise.reject(new Error('Failed to create the video session.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.UPLOAD_VIDEO_FAILED, payload: error });
      console.error('Error to creating video session:', error);
      return Promise.reject(error);
  }
};

export const getAllMergeVideo = (videoSessionId) => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/video/merge-request/by-session/${videoSessionId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.FETCH_MERGE_VIDEO_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.FETCH_MERGE_VIDEO_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteMergeVideo= (id) => async (dispatch, getState) => {   
  try { 
     
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/video/merge-request-item/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.DELETE_MERGE_VIDEO_SUCCESS,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.DELETE_MERGE_VIDEO_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const MergeAllVideo= (data) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video/merge_final_video_new`;
      const response = await axios.post(
        url,
          data,
          {
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.FINAL_MERGE_VIDEO_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.FINAL_MERGE_VIDEO_FAILED, payload: null });
          return Promise.reject(new Error(response.message||'Failed to merge the video .'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.FINAL_MERGE_VIDEO_FAILED, payload: error });
      console.error('Error to merging video:', error);
      return Promise.reject(error);
  }
};

export const MergeVideolist = (mergeVideoRequestId) => async (dispatch, getState) => {
  try { 
   
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      // `${process.env.REACT_APP_API_ENDPOINT}/video/get_final_merged_videos/${mergeVideoRequestId}`,
      
`${process.env.REACT_APP_API_ENDPOINT}/video_enhancement/video-enhancement-status/${mergeVideoRequestId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.LIST_MERGE_VIDEO_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.LIST_MERGE_VIDEO_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const createStepAndHeading= (data) => async (dispatch, getState) => {
  try { 
    
    const access_token = getState().auth.access_token;

    const encodedText = encodeURIComponent(data);
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/video/get_stepnumber_heading?textual_data=${encodedText}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response.data ) {
      dispatch({type:CONSTANTS.DOWNLOAD_ZIP_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.DOWNLOAD_ZIP_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

// export const createStepAndHeading= (data) => async (dispatch, getState) => {
//   try { 

//     const payload ={
//       textual_data:data
//     }
//     const access_token = getState().auth.access_token;
//     const response = await axios.post(
//       `${process.env.REACT_APP_API_ENDPOINT}/video/get_stepnumber_heading`,payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${access_token}`,
//         },
//       }
//     );
//     if (response.data ) {
//       dispatch({type:CONSTANTS.DOWNLOAD_ZIP_SUCCESS ,payload:response.data})
//       return response.data;
//     }else {
//       dispatch({type:CONSTANTS.DOWNLOAD_ZIP_FAILED,payload:null})
//       return Promise.reject(new Error(response.message));
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

//Key / Value management

export const getAllKeyVAlue = () => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/key_value/get_all`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.GET_KEY_VALUE_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.GET_KEY_VALUE_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};


export const updateKeyValue= (itemId, data) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/key_value/edit/${itemId}`;
      const response = await axios.put(
        url,
          data,
          {
              headers: {
                 ContentType: 'application/json', 
                 Accept: 'application/json', 
                 Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.UPDATE_KEY_VALUE_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.UPDATE_KEY_VALUE_FAILED, payload: null });
          return Promise.reject(new Error('Failed to generate image and script.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.UPDATE_KEY_VALUE_FAILED, payload: error });
      console.error('Error to generating image and script:', error);
      return Promise.reject(error);
  }
};

export const deleteKeyValue= (id) => async (dispatch, getState) => {   
  try { 
     
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/key_value/delete/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200) {
      dispatch({type:CONSTANTS.DELETE_KEY_VALUE_SUCCESS,payload:response.data})
      return response.data;
    } else {
      dispatch({type:CONSTANTS.DELETE_KEY_VALUE_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const createKeyValue= (data) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/key_value/add`;
      const response = await axios.post(
        url,
          data,
          {
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.CREATE_KEY_VALUE_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.CREATE_KEY_VALUE_FAILED, payload: null });
          return Promise.reject(new Error('Failed to create the video session.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.CREATE_KEY_VALUE_FAILED, payload: error });
      console.error('Error to creating video session:', error);
      return Promise.reject(error);
  }
};

export const getDuration = (id) => async (dispatch, getState) => {
  try { 

    const access_token = getState().auth.access_token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/video/merge-request/by-session/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.GET_DURATION_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.GET_DURATION_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const videoEnhancement= (data) => async (dispatch, getState) => {
  try {
      const access_token = getState().auth.access_token;
      const url=`${process.env.REACT_APP_API_ENDPOINT}/video_enhancement/save_video_enhancement_data`;
      const response = await axios.post(
        url,
          data,
          {
              headers: {
                  'Content-Type': 'multipart/form-data',
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );

      if (response && response.data) {
          dispatch({ type: CONSTANTS.VIDEO_ENHANCEMENT_SUCCESS, payload: response.data });
          return response.data;
      } else {
          dispatch({ type: CONSTANTS.VIDEO_ENHANCEMENT_FAILED, payload: null });
          return Promise.reject(new Error('Failed to create the video session.'));
      }
  } catch (error) {
      dispatch({ type: CONSTANTS.VIDEO_ENHANCEMENT_FAILED, payload: error });
      console.error('Error to creating video session:', error);
      return Promise.reject(error);
  }
};

export const deleteMergeList= (id) => async (dispatch, getState) => { 
  try {
    const access_token = getState().auth.access_token;
    const response = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/video_enhancement/delete_video_enhancement_input/${id}`,
      
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.DELETE_MERGE_LIST_SUCCESS,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.DELETE_MERGE_LIST_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const generateVideo = (id) => async (dispatch, getState) => {
  try { 

    const access_token = getState().auth.access_token;
    const data={};
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/video_enhancement/re_generate_video/${id}`,data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.REGENERATE_MERGE_LIST_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.REGENERATE_MERGE_LIST_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};

export const regenerateVideo = (id,videoSessionId) => async (dispatch, getState) => {
  try { 

    const access_token = getState().auth.access_token;
    const data={};
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/video/preprocessed-video-again/?merge_request_item_id=${id}&video_session_id=${videoSessionId}`,data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.REGENERATE_UPLOAD_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.REGENERATE_UPLOAD_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};


export const rearrangeVideo = (data) => async (dispatch, getState) => {
  try { 
    const access_token = getState().auth.access_token;
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/video/merge-video-list-sequence`,data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    if (response && response.status === 200 && response.data) {
      dispatch({type:CONSTANTS.REARRANGE_VIDEOS_SUCCESS ,payload:response.data})
      return response.data;
    }else {
      dispatch({type:CONSTANTS.REARRANGE_VIDEOS_FAILED,payload:null})
      return Promise.reject(new Error(response.message));
    }
  } catch (error) {
    console.log(error);
  }
};












{/*export const sessionAlreadyLunched = (data) => async (dispatch, getState) => {

  try {
      const access_token = getState().auth.access_token;
      const response = await axios.post(
          `https://1bd0-14-194-97-174.ngrok-free.app/api/v1/session/resume_session/${data}`,{},
          
          {
              headers: {
                  Authorization: `Bearer ${access_token}`,
              },
          }
      );
      console.log("response",response);

      if (response && response.data) {
          // dispatch({ type: CONSTANTS.CREATE_FAQ_SUCCESS, payload: response.data });
          return response.data;
      } else {
          // dispatch({ type: CONSTANTS.CREATE_FAQ_FAILED, payload: null });
          return Promise.reject(new Error('Failed to upload the audio file.'));
      }
  } catch (error) {
      // dispatch({ type: CONSTANTS.CREATE_FAQ_FAILED, payload: error });
      console.error('Error uploading FAQ audio:', error);
      return Promise.reject(error);
  }
};*/}

